import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters} from 'src/modules/entitlements/typedef';

export const mcpUserEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementsFilters
>('mcpUserEntitlementsState', undefined);

export const mcpUserEntitlementsStateActions = mcpUserEntitlementsStateSlice.actions;
export const mcpUserEntitlementsStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    EntitlementsFilters
> = state => state.userPage.tabs.userEntitlements.mcp.userEntitlements.state;
